import { render, staticRenderFns } from "./NewProjectShort.vue?vue&type=template&id=291d8dc3&"
import script from "./NewProjectShort.vue?vue&type=script&lang=js&"
export * from "./NewProjectShort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports